import {SqliteConnectionOptions} from "../driver/sqlite/SqliteConnectionOptions";
import {CordovaConnectionOptions} from "../driver/cordova/CordovaConnectionOptions";
import {SqljsConnectionOptions} from "../driver/sqljs/SqljsConnectionOptions";
import { WebSqlConnectionOptions } from "../driver/websql/WebSqlConnectionOptions";

/**
 * ConnectionOptions is an interface with settings and options for specific connection.
 * Options contain database and other connection-related settings.
 * Consumer must provide connection options for each of your connections.
 */
export type ConnectionOptions = SqliteConnectionOptions | CordovaConnectionOptions | SqljsConnectionOptions | WebSqlConnectionOptions;
